/*
 * Gourmet Easy mega menu — hover-intent layer on top of Dawn's accessible
 * <header-menu>/<details> disclosure (details-disclosure.js). Native click
 * and keyboard (Enter/Space to toggle, Tab to move focus) keep working
 * unchanged; this only adds pointer hover-open with a close delay so the
 * diagonal move from the nav link into the panel doesn't dismiss it, plus
 * Escape-to-close.
 */
(() => {
  const CLOSE_DELAY = 120;

  function init() {
    const wrappers = document.querySelectorAll('.ge-mega-menu-wrapper');

    wrappers.forEach((wrapper) => {
      const details = wrapper.querySelector('details.ge-mega-menu');
      const summary = wrapper.querySelector('summary');
      if (!details || !summary) return;

      let closeTimer = null;

      const open = () => {
        window.clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          closeOthers(details);
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      };

      const scheduleClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      };

      wrapper.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        open();
      });

      wrapper.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'touch') return;
        scheduleClose();
      });

      wrapper.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
      });
    });

    function closeOthers(current) {
      wrappers.forEach((wrapper) => {
        const details = wrapper.querySelector('details.ge-mega-menu');
        if (details && details !== current) {
          details.removeAttribute('open');
          const summary = wrapper.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
